import { IFormSubmissionListItem, IFormSubmissionMeta } from '../api/types';

export type TFormSubmissionsList = {
  [formId: string]: FormSubmissionListItem;
};

export class FormSubmissionMeta implements IFormSubmissionMeta {
  readonly id: number;
  readonly createdAt: Date;

  constructor({ id, createdAt }: IFormSubmissionMeta) {
    this.id = id;
    this.createdAt = new Date(createdAt);
  }
}

export class FormSubmissionListItem implements IFormSubmissionListItem {
  readonly id: number;
  readonly name: string;
  readonly submissions: IFormSubmissionMeta[];

  constructor({ id, name, submissions }: IFormSubmissionListItem) {
    this.id = id;
    this.name = name;
    this.submissions = submissions.map(submission => new FormSubmissionMeta(submission));
  }
}
